<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="padding-top:100px;">Acknowledgement</h1>
<p>A big thank you to Austin Macauley for accepting my book for publishing. Also the editor, the designer, and my spouse, Joe.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?9922d6e0